export default __webpack_public_path__ + "static/media/imprint-data-policy-2k.e3b577a9.jpg";